/* Ivalro — animaciones del carrito (vanilla JS + Web Animations API, sin librerías).
   · Además: ✓ verde en el botón al añadir, precio/ahorro que cuentan al cambiar de pack, barras del
     carrito que se rellenan (con confeti al conseguir el envío gratis) y contador tipo cuentakilómetros.
   · Al pulsar cualquier botón de añadir (ficha, CTA final, portada "+", test, packs, recomendaciones
     del carrito), una partícula con la miniatura del producto sale del botón y vuela en arco hasta el
     icono del carrito (o hasta la lista del carrito si ya está abierto). El cajón del carrito espera a
     que la partícula aterrice para abrirse, y el icono rebota al recibirla.
   · Al eliminar un artículo del carrito, la fila se desliza hacia fuera y se pliega, con un pequeño
     estallido de partículas desde la papelera.
   · Con "reducir movimiento" activado en el sistema no se anima nada. */
(function () {
  if (window.__ivcFlyInit) return;
  window.__ivcFlyInit = true;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (reduce || !Element.prototype.animate) return;

  var FLIGHT_MS = 680;
  var landingAt = 0; // momento (performance.now) en que aterriza la última partícula

  /* ---------- estilos (inyectados: así no hace falta otro archivo CSS en las dos plantillas) ---------- */
  var css =
    '.ivc-fly{position:fixed;left:0;top:0;z-index:2147483000;pointer-events:none;border-radius:50%;will-change:transform,opacity}' +
    '.ivc-fly-thumb{width:56px;height:56px;margin:-28px 0 0 -28px;background:#fff center/cover no-repeat;border:2px solid #fff;' +
    'box-shadow:0 10px 24px -8px rgba(20,24,22,.45),0 0 0 1px rgba(20,24,22,.06)}' +
    '.ivc-fly-dot{width:12px;height:12px;margin:-6px 0 0 -6px}' +
    '.ivc-fly-ring{position:fixed;left:0;top:0;width:44px;height:44px;margin:-22px 0 0 -22px;border-radius:50%;' +
    'border:2px solid currentColor;pointer-events:none;z-index:2147483000}' +
    '#cart-icon-bubble.ivc-cart-hit{animation:ivcHit .55s cubic-bezier(.34,1.56,.64,1)}' +
    '#cart-icon-bubble.ivc-cart-hit .ivh-cart-count,#cart-icon-bubble.ivc-cart-hit .cart-count-bubble{animation:ivcBadge .5s cubic-bezier(.34,1.56,.64,1) .08s both}' +
    '@keyframes ivcHit{0%{transform:scale(1)}30%{transform:scale(1.28) rotate(-8deg)}60%{transform:scale(.94) rotate(4deg)}100%{transform:scale(1)}}' +
    '@keyframes ivcBadge{0%{transform:scale(.3)}100%{transform:scale(1)}}' +
    '.cart-item.ivc-saliendo{pointer-events:none}';

  /* ---------- utilidades ---------- */
  function center(r) { return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function visible(r) { return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth; }
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function accentOf(btn) {
    var c = getComputedStyle(btn).backgroundColor;
    if (!c || c === 'transparent' || /rgba\(0, 0, 0, 0\)/.test(c)) c = getComputedStyle(btn).color;
    return c || '#2e4a3a';
  }

  // Miniatura del producto más cercana al botón pulsado (tarjeta, pack, test, ficha...)
  function thumbFor(btn) {
    var box = btn.closest('.hm-producto-card, .hmq-tarjeta, .hmp-item, .ivc-cross-item, .card-wrapper, .card, li, article');
    var img = box && box.querySelector('img');
    if (!img) {
      // ficha de producto y su botón final: la foto principal de la galería
      if (btn.closest('.pf-ficha, .pf-cta-caja, .pf-sec, product-form')) img = document.querySelector('.pf-galeria-main img');
    }
    if (!img) {
      var el = btn;
      for (var i = 0; i < 5 && el && !img; i++) { el = el.parentElement; img = el && el.querySelector('img'); }
    }
    return img ? (img.currentSrc || img.src) : '';
  }

  // Destino: el icono del carrito, o la primera línea del carrito si el cajón ya está abierto
  function targetPoint() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) {
      var t = drawer.querySelector('.cart-item .cart-item__media') || drawer.querySelector('.ivc-vacio-cabecera') || drawer.querySelector('.drawer__header');
      if (t) return { pt: center(t.getBoundingClientRect()), inDrawer: true };
    }
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      var r = icon.getBoundingClientRect();
      if (visible(r)) return { pt: center(r), icon: icon };
    }
    return { pt: { x: window.innerWidth - 36, y: 30 } };
  }

  /* ---------- la partícula ---------- */
  function fly(fromRect, src, color, delay) {
    var from = center(fromRect);
    var dest = targetPoint();
    var to = dest.pt;
    var dx = to.x - from.x, dy = to.y - from.y;
    var dist = Math.sqrt(dx * dx + dy * dy);
    // arco: el punto de control sube por encima del más alto de los dos extremos
    // (sin salirse por arriba de la pantalla cuando el destino es el icono de la cabecera)
    var cx = from.x + dx * 0.35, cy = Math.max(28, Math.min(from.y, to.y) - Math.min(220, 60 + dist * 0.25));
    var dur = Math.round(Math.min(900, Math.max(520, FLIGHT_MS * (0.6 + dist / 1400))));
    landingAt = Math.max(landingAt, performance.now() + (delay || 0) + dur);

    function path(steps, s0, s1) {
      var kf = [];
      for (var i = 0; i <= steps; i++) {
        var t = easeInOut(i / steps), u = 1 - t;
        var x = u * u * from.x + 2 * u * t * cx + t * t * to.x;
        var y = u * u * from.y + 2 * u * t * cy + t * t * to.y;
        var s = s0 + (s1 - s0) * t;
        kf.push({ transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + s.toFixed(3) + ')', opacity: i === steps ? 0.15 : 1 });
      }
      kf[0].opacity = 0;
      if (kf[1]) kf[1].opacity = 1;
      return kf;
    }

    // estela de tres puntos con el color del botón
    for (var k = 3; k >= 1; k--) {
      var dot = document.createElement('span');
      dot.className = 'ivc-fly ivc-fly-dot';
      dot.style.background = color;
      document.body.appendChild(dot);
      run(dot, path(28, 0.9 - k * 0.15, 0.25), { duration: dur, delay: (delay || 0) + k * 45, easing: 'linear', fill: 'both' });
    }

    var p = document.createElement('span');
    if (src) {
      p.className = 'ivc-fly ivc-fly-thumb';
      p.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
    } else {
      p.className = 'ivc-fly ivc-fly-dot';
      p.style.background = color;
      p.style.width = p.style.height = '18px';
      p.style.margin = '-9px 0 0 -9px';
    }
    document.body.appendChild(p);
    run(p, path(36, 1, src ? 0.32 : 0.6), { duration: dur, delay: delay || 0, easing: 'linear', fill: 'both' }, function () { land(dest, color); });
  }

  function remove(el) { return function () { if (el && el.parentNode) el.parentNode.removeChild(el); }; }
  // Lanza una animación y garantiza que el elemento se elimina aunque el navegador la congele
  function run(el, kf, opts, then) {
    var a = el.animate(kf, opts);
    var done = false;
    function fin(ok) { if (done) return; done = true; remove(el)(); if (ok && then) then(); }
    a.finished.then(function () { fin(true); }, function () { fin(false); });
    setTimeout(function () { fin(true); }, (opts.delay || 0) + opts.duration + 600);
    return a;
  }

  function land(dest, color) {
    // onda en el punto de aterrizaje
    var ring = document.createElement('span');
    ring.className = 'ivc-fly-ring';
    ring.style.color = color;
    document.body.appendChild(ring);
    run(ring, [
      { transform: 'translate(' + dest.pt.x + 'px,' + dest.pt.y + 'px) scale(.35)', opacity: 0.7 },
      { transform: 'translate(' + dest.pt.x + 'px,' + dest.pt.y + 'px) scale(1.5)', opacity: 0 }
    ], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
    // rebote del icono (la clase también hace "pop" en el contador cuando Shopify lo repinta)
    var icon = dest.icon || document.getElementById('cart-icon-bubble');
    if (icon && !dest.inDrawer) {
      icon.classList.remove('ivc-cart-hit'); void icon.offsetWidth; icon.classList.add('ivc-cart-hit');
      setTimeout(function () { icon.classList.remove('ivc-cart-hit'); }, 1400);
    }
  }

  /* ---------- 1) botones de añadir ---------- */
  var ADD_SEL = 'button[name="add"], [data-ivc-cross-add], .hmq-anadir, .hmp-anadir';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(ADD_SEL);
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var color = accentOf(btn);
    if (btn.classList.contains('hmp-anadir')) {
      // pack: dos partículas, una desde cada bote
      var pack = btn.closest('.hmp-pack');
      var items = pack ? pack.querySelectorAll('.hmp-item') : [];
      for (var i = 0; i < items.length; i++) {
        var im = items[i].querySelector('img');
        fly(items[i].getBoundingClientRect(), im ? (im.currentSrc || im.src) : '', color, i * 120);
      }
      if (items.length) return;
    }
    fly(btn.getBoundingClientRect(), thumbFor(btn), color, 0);
  }, true);

  /* ---------- 2) el cajón del carrito espera a que aterrice la partícula ---------- */
  customElements.whenDefined('cart-drawer').then(function () {
    var CD = customElements.get('cart-drawer');
    if (!CD || CD.prototype.__ivcPatched) return;
    CD.prototype.__ivcPatched = true;
    var open = CD.prototype.open;
    CD.prototype.open = function (triggeredBy) {
      var wait = landingAt - performance.now();
      var self = this, args = arguments;
      if (wait > 0 && !this.classList.contains('active')) {
        setTimeout(function () { open.apply(self, args); }, Math.min(wait + 60, 1100));
        return;
      }
      return open.apply(this, args);
    };
  });

  /* ---------- 3) eliminar un artículo ---------- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('cart-remove-button');
    if (!rm) return;
    var row = rm.closest('.cart-item');
    var b = rm.getBoundingClientRect(), o = center(b);
    // estallido de 8 partículas desde la papelera
    var color = '#c0504d'; // rojo suave de "eliminar"
    for (var i = 0; i < 10; i++) {
      var a = (Math.PI * 2 * i) / 10 + Math.random() * 0.4, d = 26 + Math.random() * 20;
      var s = document.createElement('span');
      s.className = 'ivc-fly ivc-fly-dot';
      s.style.background = color; s.style.width = s.style.height = '7px'; s.style.margin = '-3.5px 0 0 -3.5px';
      document.body.appendChild(s);
      run(s, [
        { transform: 'translate(' + o.x + 'px,' + o.y + 'px) scale(1)', opacity: 1 },
        { transform: 'translate(' + (o.x + Math.cos(a) * d * 0.7) + 'px,' + (o.y + Math.sin(a) * d * 0.7) + 'px) scale(.9)', opacity: 0.9, offset: 0.45 },
        { transform: 'translate(' + (o.x + Math.cos(a) * d) + 'px,' + (o.y + Math.sin(a) * d) + 'px) scale(.2)', opacity: 0 }
      ], { duration: 560, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    if (!row) return;
    // la fila se desliza hacia la derecha, se desvanece y se pliega (Shopify la quita al repintar)
    row.classList.add('ivc-saliendo');
    var h = row.getBoundingClientRect().height;
    row.animate([
      { transform: 'translateX(0)', opacity: 1, maxHeight: h + 'px' },
      { transform: 'translateX(36px)', opacity: 0, maxHeight: h + 'px', offset: 0.55 },
      { transform: 'translateX(48px)', opacity: 0, maxHeight: '0px', paddingTop: '0px', paddingBottom: '0px' }
    ], { duration: 420, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
  }, true);

  /* =====================================================================
     4) Microanimaciones de venta
     ===================================================================== */
  var css2 =
    // ✓ en el botón tras añadir
    '.ivc-ok{background:#2f7d4f !important;background-image:none !important;color:#fff !important;transition:background-color .25s ease}' +
    '.ivc-ok>*:not(.ivc-ok-check){visibility:hidden !important}' +
    '.ivc-ok-check{position:absolute;inset:0;display:grid;place-items:center;pointer-events:none;color:#fff}' +
    '.ivc-ok-check svg{width:24px;height:24px;overflow:visible;animation:ivcOkPop .45s cubic-bezier(.34,1.56,.64,1) both}' +
    '.ivc-ok-check path{stroke-dasharray:24;stroke-dashoffset:24;animation:ivcOkDraw .35s ease-out .1s forwards}' +
    '@keyframes ivcOkPop{from{transform:scale(.4);opacity:0}to{transform:none;opacity:1}}' +
    '@keyframes ivcOkDraw{to{stroke-dashoffset:0}}' +
    // contador tipo cuentakilómetros
    '.ivh-cart-count.ivc-odo-run{overflow:hidden}' +
    '.ivc-odo-col{display:flex;flex-direction:column;align-items:center}' +
    '.ivc-odo-col>span{display:block;text-align:center}' +
    // confeti
    '.ivc-progreso-barra span{transition:none !important}' +
    '.ivc-confeti{position:fixed;left:0;top:0;width:7px;height:10px;border-radius:2px;pointer-events:none;z-index:2147483001}';
  // Los estilos solo hacen falta al interactuar: se añaden entonces y no durante la carga (recalculan toda la página)
  function ponerEstilos() {
    removeEventListener('pointerdown', ponerEstilos, true);
    removeEventListener('keydown', ponerEstilos, true);
    var st = document.createElement('style');
    st.textContent = css + css2;
    document.head.appendChild(st);
  }
  addEventListener('pointerdown', ponerEstilos, true);
  addEventListener('keydown', ponerEstilos, true);

  /* ---------- números: interpreta "€48,33", "$56.70", "32,22 €" y cuenta de un valor a otro ---------- */
  var NUM_RE = /(\d+(?:[.\s ]\d{3})*)(?:([.,])(\d{2}))?(?!\d)/;
  function parseNum(s) {
    var m = (s || '').match(NUM_RE);
    if (!m) return null;
    var thousands = m[2] === ',' ? '.' : ',';
    var ent = parseInt(m[1].replace(/[.\s ,]/g, ''), 10);
    return { v: ent + (m[3] ? parseInt(m[3], 10) / 100 : 0), match: m[0], dec: m[2] || '', thousands: thousands, decimals: !!m[3] };
  }
  function fmtLike(p, v) {
    var ent = Math.floor(v + 1e-9), dec = Math.round((v - ent) * 100);
    if (dec === 100) { ent++; dec = 0; }
    var e = String(ent);
    if (ent >= 1000) e = e.replace(/\B(?=(\d{3})+(?!\d))/g, p.thousands);
    return p.decimals ? e + p.dec + (dec < 10 ? '0' : '') + dec : e;
  }
  function countText(el, fromText, toText, ms) {
    var a = parseNum(fromText), b = parseNum(toText);
    if (!el || !a || !b || a.v === b.v) { if (el) el.textContent = toText; return; }
    var t0 = null, dur = ms || 480;
    var token = (el.__ivcCount = (el.__ivcCount || 0) + 1);
    function tick(ts) {
      if (el.__ivcCount !== token) return; // otra animación más reciente sobre el mismo elemento
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = k < 1 ? toText.replace(b.match, fmtLike(b, a.v + (b.v - a.v) * e)) : toText;
      if (k < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    setTimeout(function () { if (el.__ivcCount === token) el.textContent = toText; }, dur + 400);
  }

  /* ---------- A) Selector de packs de la ficha: precio y ahorro cuentan al cambiar ---------- */
  var PACK_TARGETS = '.pf-precio-ahora, .pf-ahorro, [data-pf-cta-precio]';
  document.addEventListener('click', function (e) {
    var pack = e.target.closest && e.target.closest('[data-pf-pack]');
    if (!pack) return;
    var antes = Array.prototype.map.call(document.querySelectorAll(PACK_TARGETS), function (el) {
      return { el: el, txt: el.textContent, oculto: el.hidden };
    });
    // pf-scripts.js cambia los textos en este mismo clic; justo después animamos del valor viejo al nuevo
    setTimeout(function () {
      antes.forEach(function (o) {
        var nuevo = o.el.textContent;
        if (o.oculto || o.el.hidden || nuevo === o.txt) return;
        o.el.textContent = o.txt;
        countText(o.el, o.txt, nuevo, 520);
      });
    }, 0);
  }, true);

  /* ---------- B) ✓ verde en el botón cuando el producto entra de verdad en el carrito ---------- */
  var lastAdd = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"], [data-ivc-cross-add]');
    if (b) lastAdd = { btn: b, t: Date.now() };
  }, true);
  function showOk(btn) {
    if (!btn || !btn.isConnected || btn.classList.contains('ivc-ok')) return;
    if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
    var ck = document.createElement('span');
    ck.className = 'ivc-ok-check';
    ck.setAttribute('aria-hidden', 'true');
    ck.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    btn.appendChild(ck);
    btn.classList.add('ivc-ok');
    setTimeout(function () {
      btn.classList.remove('ivc-ok');
      if (ck.parentNode) ck.parentNode.removeChild(ck);
    }, 1300);
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var p = _fetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (/\/cart\/add/.test(url) && /post/i.test(method) && lastAdd && Date.now() - lastAdd.t < 6000) {
        var btn = lastAdd.btn;
        p.then(function (r) {
          if (!r.ok) return;
          r.clone().json().then(function (d) { if (d && !d.status) showOk(btn); }, function () {});
        }, function () {});
      }
    } catch (err) {}
    return p;
  };

  /* ---------- C) Barras del carrito (envío gratis y pack de 4) + contador del icono ---------- */
  var BAR_MS = 750;
  var booted = false; // el primer escaneo (al cargar la página) no anima nada
  var prevBars = {};   // { 'drawer': [pct, pct], 'page': [...] }
  var prevOk = {};     // ¿envío gratis ya conseguido?
  var prevTxt = {};    // texto "Te faltan X"
  var prevCount = null;

  function pctOf(span) { return parseFloat(span.style.width) || 0; }
  function ctxOf(el) { return el.closest('cart-drawer') ? 'drawer' : 'page'; }

  function confeti(anchor) {
    var r = anchor.getBoundingClientRect();
    var colores = ['#2e4a3a', '#7fa68a', '#d4b06a', '#c94f3c', '#4b5a9e', '#e8c8a0'];
    for (var i = 0; i < 26; i++) {
      var c = document.createElement('span');
      c.className = 'ivc-confeti';
      c.style.background = colores[i % colores.length];
      document.body.appendChild(c);
      var x0 = r.left + r.width * (0.15 + Math.random() * 0.7), y0 = r.top + r.height / 2;
      var dx = (Math.random() - 0.5) * 160, up = 50 + Math.random() * 70, down = 90 + Math.random() * 120;
      var rot = (Math.random() - 0.5) * 720;
      run(c, [
        { transform: 'translate(' + x0 + 'px,' + y0 + 'px) rotate(0) scale(.6)', opacity: 1 },
        { transform: 'translate(' + (x0 + dx * 0.6) + 'px,' + (y0 - up) + 'px) rotate(' + rot * 0.5 + 'deg) scale(1)', opacity: 1, offset: 0.35 },
        { transform: 'translate(' + (x0 + dx) + 'px,' + (y0 - up + down) + 'px) rotate(' + rot + 'deg) scale(.9)', opacity: 0 }
      ], { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(.2,.6,.4,1)' });
    }
  }

  function odometer(badge, from, to) {
    var h = badge.clientHeight || 16;
    badge.classList.add('ivc-odo-run');
    var up = to > from;
    badge.innerHTML = '<span class="ivc-odo-col" style="line-height:' + h + 'px"><span style="height:' + h + 'px">' + (up ? from : to) +
      '</span><span style="height:' + h + 'px">' + (up ? to : from) + '</span></span>';
    var col = badge.firstChild;
    var a = col.animate(
      up ? [{ transform: 'translateY(0)' }, { transform: 'translateY(-' + h + 'px)' }]
         : [{ transform: 'translateY(-' + h + 'px)' }, { transform: 'translateY(0)' }],
      { duration: 420, easing: 'cubic-bezier(.34,1.4,.64,1)', fill: 'forwards' });
    function fin() { if (badge.isConnected) { badge.classList.remove('ivc-odo-run'); badge.textContent = to; } }
    a.finished.then(fin, fin);
    setTimeout(fin, 900);
  }

  function scan() {
    // barras de progreso nuevas (Shopify las repinta enteras al cambiar el carrito)
    document.querySelectorAll('.ivc-progreso:not([data-ivc-ok])').forEach(function (box) {
      box.setAttribute('data-ivc-ok', '1');
      var ctx = ctxOf(box);
      var items = box.querySelectorAll('.ivc-progreso-item');
      var bars = Array.prototype.map.call(items, function (it) { return it.querySelector('.ivc-progreso-barra span'); });
      // Shopify puede repintar el carrito dos veces seguidas: si una barra estaba a medio rellenarse,
      // la nueva continúa desde el punto en que iba (no vuelve a saltar).
      var old = prevBars[ctx] || [];
      var now = performance.now();
      prevBars[ctx] = bars.map(function (sp, i) {
        if (!sp) return null;
        var to = pctOf(sp), o = old[i];
        // primera vez que aparece la barra tras cargar la página (p. ej. carrito que estaba vacío): se rellena desde 0
        if (o == null && booted) o = { from: 0, to: 0, t0: 0 };
        var desde = o == null ? to : (now - o.t0 < BAR_MS ? o.from + (o.to - o.from) * (1 - Math.pow(1 - (now - o.t0) / BAR_MS, 3)) : o.to);
        if (o != null && Math.abs(desde - to) > 0.1) {
          var t0 = now, dur = BAR_MS;
          sp.style.width = desde + '%';
          (function anim(span, from, target) {
            function tick(ts) {
              var k = Math.min(1, (performance.now() - t0) / dur), e = 1 - Math.pow(1 - k, 3);
              if (!span.isConnected) return;
              span.style.width = (from + (target - from) * e) + '%';
              if (k < 1) requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
            setTimeout(function () { if (span.isConnected) span.style.width = target + '%'; }, dur + 300);
          })(sp, desde, to);
          return { from: desde, to: to, t0: t0 };
        }
        return { from: to, to: to, t0: 0 };
      });

      // "Te faltan X €": la cifra cuenta hacia abajo
      var envio = items[0];
      var strong = envio && envio.querySelector('.ivc-progreso-texto strong');
      var FALT_MS = 700;
      if (strong) {
        var nuevo = strong.textContent, run0 = prevTxt[ctx];
        if (run0 && run0.to !== nuevo) {
          // de lo que se mostraba (aunque fuera un valor a medio contar) al nuevo importe
          strong.textContent = run0.shown();
          var desdeTxt = strong.textContent;
          countText(strong, desdeTxt, nuevo, FALT_MS);
          prevTxt[ctx] = track(strong, desdeTxt, nuevo, FALT_MS);
        } else if (run0 && run0.to === nuevo && performance.now() - run0.t0 < run0.ms) {
          // repintado repetido con el mismo destino: continuar la cuenta en curso
          var actual = run0.shown(), resto = run0.ms - (performance.now() - run0.t0);
          strong.textContent = actual;
          countText(strong, actual, nuevo, Math.max(120, resto));
          prevTxt[ctx] = track(strong, actual, nuevo, Math.max(120, resto));
        } else {
          prevTxt[ctx] = track(strong, nuevo, nuevo, 0);
        }
      } else {
        prevTxt[ctx] = null;
      }

      // confeti al conseguir el envío gratis
      var ok = !!(envio && envio.classList.contains('ivc-progreso-item--ok'));
      if (ok && prevOk[ctx] === false) setTimeout(function () { confeti(envio); }, 350);
      prevOk[ctx] = ok;
    });

    // contador del icono del carrito
    var badge = document.querySelector('#cart-icon-bubble [data-ivh-cart-count]:not([data-ivc-ok])');
    if (badge) {
      badge.setAttribute('data-ivc-ok', '1');
      var n = badge.hidden ? 0 : parseInt(badge.textContent, 10) || 0;
      if (prevCount !== null && n > 0 && n !== prevCount) odometer(badge, prevCount, n);
      prevCount = n;
    }
  }
  function track(el, fromTxt, toTxt, ms) {
    var t0 = performance.now(), a = parseNum(fromTxt), b = parseNum(toTxt);
    return { to: toTxt, t0: t0, ms: ms, shown: function () {
      if (!a || !b || !ms) return toTxt;
      var k = Math.min(1, (performance.now() - t0) / ms), e = 1 - Math.pow(1 - k, 3);
      return k >= 1 ? toTxt : toTxt.replace(b.match, fmtLike(b, a.v + (b.v - a.v) * e));
    } };
  }
  // texto final de un contador en marcha (para no guardar un valor intermedio)
  function countTarget(el) { return el.getAttribute('data-ivc-final') || el.textContent; }
  var _countText = countText;
  countText = function (el, a, b, ms) { if (el) el.setAttribute('data-ivc-final', b); _countText(el, a, b, ms); };

  // Escaneo agrupado: en el siguiente fotograma o, si el navegador no pinta (pestaña en 2º plano), a los 60 ms
  var pending = false;
  function flush() { if (!pending) return; pending = false; scan(); }
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(flush);
    setTimeout(flush, 60);
  }).observe(document.body, { childList: true, subtree: true });
  scan();
  booted = true;
})();
